@if(label()){
  <label class="label">{{label()}}</label>
}
<div role="button"
  class="controls" 
  [attr.data-trackingid]="trackingIdPrefix" 
  [ngClass]="{
      'open': showMenu,
      'full-width': fullWidth,
      'invalid': isInvalid,
      'disabled': disabled
    }"
  (click)="setShowMenu(!showMenu)"
  (clickOutside)="setShowMenu(false)">
  <ng-content>
    <!-- menu placeholder goes here -->
  </ng-content>
  <button title="toggle dropdown" 
    class="arrow"
    type="button"
    [ngClass]="{'open': showMenu}">
  </button>
</div>
<div *ngIf="showMenu" class="menu" [ngClass]="{'full-width': fullWidth}">
  <ul>
    @for(option of options(); track option.value; let i = $index){
      <li>
        <button class="menu-option" [ngClass]="{
          'selected': option.value === selectedOption?.value,
          'divided': i === dividerIndex
        }"  [attr.data-trackingid]="trackingIdPrefix + '_' + option.value" type="button" (click)="selectOption(option)">
        @if(option.icon){
          <lib-icon [name]="option.icon"></lib-icon>
        }
        {{ option.label }}
      </button>
      </li>
      }
  </ul>
</div>